import type { AnchorHTMLAttributes } from 'react';
import { normalizeUrl } from '@halo/utils';
import InlineFix from '../../../inline-fix';
import classes from './index.module.scss';

export interface LinkBaseProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  selected?: boolean;
}

export default forwardRef(function LinkBase(
  { selected, href, children, className, ...attributes }: LinkBaseProps,
  ref: any
) {
  const href_ = useMemo(() => normalizeUrl(href!), [href]);

  return (
    <a
      className={cls(classes.link, selected && classes.focus, className)}
      ref={ref}
      href={href_}
      target="_blank"
      rel="noreferrer"
      {...attributes}
    >
      <InlineFix />
      {children}
      <InlineFix />
    </a>
  );
});
